// extracted by mini-css-extract-plugin
export default {"container":"CG-z","ratingLayout":"DG-z","ratingLabel":"EG-z"};